<div (click)="toggleCheckbox()">
  <ion-row>
    <ion-col size="1">
      @if (!checked) {
        <div class="checkbox-unchecked">
        </div>
      }
      @else {
        <div>
          <ion-icon src="assets/icon/icon-check.svg"
                    class="checkbox-unchecked" />
        </div>
      }
    </ion-col>
    <ion-col size="11"
             [class.disabled]="disabled">
      @if (isNullOrUndefined(translateString)) {
        <span>{{ label }}</span>
      }
      @if (isDefined(translateString)) {
        <span>
          {{ translateString + label | translate }}
        </span>
      }
    </ion-col>
  </ion-row>
</div>